/* eslint-disable @typescript-eslint/no-explicit-any */
import FolderIcon from '../../../../assets/folder.svg?react';
import styles from './FJMediaImportFolder.module.less';
import classNames from 'classnames';

interface Props {
    itemModel: any;
    onClick: (itemModel: any) => void;
    className: string;
}

const FJMediaImportFolder = ({ itemModel, onClick, className }: Props) => {
    return (
        <div className={classNames(styles.container, className)} onClick={() => onClick(itemModel)}>
            <FolderIcon className={styles.icon} />
            <div className={styles.name}>{itemModel.name}</div>
        </div>
    );
};

export default FJMediaImportFolder;
